import { ReactNode } from 'react';

import classNames from 'classnames';

type Props = {
  children: ReactNode;
  className?: string;
};

export const DialogButtonsWrapper = ({ className, children }: Props) => {
  return <div className={classNames('msq-dialog-buttons w-full', className)}>{children}</div>;
};
